/*
 * @Author: Qzx
 * @LastEditors: Qzx
 * @Description: axios 接口请求封装
 * @Date: 2019-03-25 11:03:23
 * @LastEditTime: 2019-07-22 19:20:09
 */
import axios from 'axios';
import qs from 'qs';

var errorHandler = function errorHandler(err) {
  return Promise.reject(err);
}; // 创建实例时设置配置的默认值


var instance = axios.create({
  timeout: 10000,
  // 设置超时10s
  withCredentials: true,
  // 跨域时是否发送cookie
  headers: {
    'content-type': 'application/x-www-form-urlencoded'
  }
});
axios.cancels = Object.create(null); // 添加请求拦截器
// 将数据字符串化

instance.interceptors.request.use(function (config) {
  if (config.method === 'post') {
    config.data = qs.stringify(config.data);
  }

  var cancelGroupName = config.cancelGroupName; // 请求唯一性

  if (cancelGroupName) {
    if (axios.cancels[cancelGroupName] && axios.cancels[cancelGroupName].cancel) {
      axios.cancels[cancelGroupName].cancel(config.url + " is still pending, the request has been canceled");
    }

    config.cancelToken = new axios.CancelToken(function (c) {
      axios.cancels[cancelGroupName] = {
        cancel: c
      };
    });
  }

  return config;
}, errorHandler); // 添加响应拦截器

instance.interceptors.response.use(function (response) {
  // 只将请求结果的data字段返回(JSON格式处理)
  var resData;

  if (typeof response.data == 'string' && /{/.test(response.data)) {
    try {
      resData = JSON.parse(response.data);
    } catch (e) {
      resData = response.data;
    }
  } else {
    resData = response.data;
  }

  return resData;
}, errorHandler);
export default instance;